<template>
  <div>
    <el-button
      v-permit:remove="'btn:payable:quoteManagement:addEdit'"
      size="small"
      type="primary"
      icon="el-icon-plus"
      @click="batchAdd"
    >{{ $t('basicData.dspBatchAddition') }}
    </el-button>

    <el-drawer
      :title="$t('basicData.dspBatchAddition')"
      :visible.sync="dialogVisible"
      direction="ltr"
      size="60%"
      @close="reset"
    >
      <div class="drawer__content">
        <div class="form-container">
          <el-form
            ref="form" :model="formData" :rules="rules"
            size="small"
          >
            <!--        报价名称：-->
            <el-form-item :label="$t('basicData.TheNameOfTheQuoteProposal')" prop="name">
              <el-input
                v-model.trim="formData.name"
                :placeholder="$t('orderDetails.pleaseInput')"
                clearable
                maxlength="50"
                show-word-limit
              />
            </el-form-item>
            <!--        生效时间：-->
            <el-form-item :label="$t('basicData.TheValidityPeriodBegins')" prop="startOfValidityPeriod">
              <el-date-picker
                v-model="formData.startOfValidityPeriod"
                type="datetime"
                :format="$i18n.locale==='zh' ? zhDate : ptDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%;"
                :picker-options="pickerOptions"
                :placeholder="$t('basicData.SelectADatetime')"
              />
            </el-form-item>
            <!--        货物类型：-->
            <el-form-item
              :label="$t('placeOrder.cargoType')"
              prop="cargoType"
            >
              <el-select
                v-model="formData.cargoType "
                filterable
                clearable
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in CARGO_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <!--        分区方案：-->
            <el-form-item :label="$t('basicData.PartitionSchemeName')">
              <el-select
                v-model="formData.partitionId"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                filterable
                clearable
                @change="getOtherFeeDetail"
              >
                <el-option
                  v-for="item in partitionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div class="title"> {{ $t('basicData.payee') }}</div>
          <el-form
            ref="tableForm"
            :model="formData"
            label-width="0"
            size="small"
            class="error-form mb5"
            :rules="rules"
          >
            <el-table
              ref="table"
              :data="formData.payableOfferPriceAddList"
              border
              style="width: 100%"
            >
              <!-- 主体 -->
              <el-table-column :label="$t('basicData.PayablePrincipal')" min-width="180">
                <template #header>
                  <div>
                    <span style="color: red;">*</span>
                    <span>{{ $t('basicData.PayablePrincipal') }}</span>
                  </div>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'payableOfferPriceAddList.' + scope.$index + '.payableEntityId'"
                    :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                  >
                    <el-select
                      v-model="scope.row.payableEntityId"
                      :placeholder="$t('basicData.PleaseSelect')"
                      filterable
                      style="width: 100%;"
                      @change="chargePayable(scope)"
                    >
                      <el-option
                        v-for="item in providerList"
                        :key="item.id"
                        :label="item.providerName + '(' + item.code + ')'"
                        :value="item.id"
                        :disabled="isOptionDisabled(scope.$index, item.id)"
                      />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <!--          网点-->
              <el-table-column :label="$t('basicData.Outlets')" min-width="180">
                <template v-slot="scope">
                  <el-form-item
                    :key="siteKey"
                    :prop="'payableOfferPriceAddList.' + scope.$index + '.siteIds'"
                  >
                    <el-select
                      v-model="scope.row.siteIds"
                      :placeholder="$t('basicData.PleaseSelect')"
                      style="width: 100%;"
                      clearable
                    >
                      <!--请先选择应收主体-->
                      <el-option v-if="!formData.payableEntityId" value="">
                        <span style="color:#f00;font-weight: bold">{{ $t('basicData.PleaseSelectThePayableEntity') }}</span>
                      </el-option>
                      <el-option
                        v-for="item in scope.row.siteData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <!--操作-->
              <el-table-column :label="$t('basicData.operate')" width="100">
                <template v-slot="scope">
                  <!--确定删除吗？-->
                  <el-popconfirm
                    :title="$t('basicData.AreYouSureYouWantToDelete')"
                    @confirm="handleDel(scope)"
                  >
                    <!--删除-->
                    <template #reference>
                      <el-button type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <div class="feet-r">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              @click="add"
            >{{ $t('basicData.Add') }}
            </el-button>
            <el-button
              :loading="isLoading"
              class="feet-btn"
              size="small" icon="el-icon-download" @click="downloadFile(1)"
            >{{ $t('collectionCenter.TemplateDownload') }}</el-button>
            <upload-excel
              class="feet-btn"
              :on-success="importProviderData"
              :but-name="$t('collectionCenter.Import')"
            />
          </div>
        </div>
        <div class="drawer__footer feet-r">
          <el-button
            :loading="isLoading"
            size="small" icon="el-icon-download" @click="downloadFile(2)"
          >{{ $t('collectionCenter.TemplateDownload') }}</el-button>
          <upload-excel
            class="feet-btn"
            :on-success="importData"
            :but-name="$t('collectionCenter.Import')"
          />
          <!--          <el-button-->
          <!--            size="small" icon="el-icon-upload" type="primary"-->
          <!--            @click="ImportFileList"-->
          <!--          >{{ $t('collectionCenter.Import') }}</el-button>-->
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { CARGO_TYPE } from '@/views/finance/enums';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
import { downloadTemplate, importLogistics } from './utils';
import { apiGetAffiliateById } from '@/api/finance/partition';
import { apiSiteQuery, apiPayableOfferPriceDetailBatchInsert } from '@/api/finance/basicData';

export default {
  name: 'DspBatchAdd',
  components: {
    'upload-excel': () => import('@/components/UploadExcel/index')
  },
  mixins: [toolRequestClass],
  data() {
    return {
      CARGO_TYPE, // 货物类型
      dialogVisible: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      formData: {
        name: '',
        startOfValidityPeriod: '',
        cargoType: '',
        partitionId: '',
        businessType: 4,
        payableOfferPriceAddList: []
      },
      subregionList: [], // 分区列表
      rules: {
        name: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },
          // '长度在 2 到 50 个字符'
          { min: 2, max: 50, message: this.$t('basicData.TheLengthBetween2And50Characters'), trigger: ['blur', 'change'] }
        ],
        startOfValidityPeriod: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        cargoType: { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
      },
      siteKey: new Date().getTime(),
      isLoading: false
    };
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 3600 * 1000; // 不能选择生效日期在当前服务时间之前
        }
      };
    }
  },
  created() {
    // 获取分区方案下拉数据
    this.getSubregionData(2);
    // 主体All
    this.getProviderPage();
    // 网点ALL
    this.getAllSiteQuery();
    // 获取费用类型
    this.getExpenseTypeList({
      state: 1, // 启用
      attribute: 2, // 应付
      accountType: 1, // 应付科目
      businessType: 4 // DSP
    });
  },
  methods: {
    // 添加主体
    add() {
      this.formData.payableOfferPriceAddList.push({
        payableEntityId: '',
        siteIds: ''
      });
    },
    handleDel(scope) {
      this.formData.payableOfferPriceAddList.splice(scope.$index, 1);
    },
    // 主体查询网点
    chargePayable(scope) {
      // 清空网点
      this.formData.payableOfferPriceAddList[scope.$index].siteIds = '';
      this.formData.payableOfferPriceAddList[scope.$index].siteData = [];
      apiSiteQuery(scope.row.payableEntityId, false).then(res => {
        if (res.code === 200) {
          this.formData.payableOfferPriceAddList[scope.$index].siteData = res.data || [];
          this.siteKey = new Date().getTime();
        }
      });
      this.$forceUpdate();
    },
    // 主体禁用选项
    isOptionDisabled(currentIndex, optionValue) {
      // 如果当前行已经选择了这个选项，不禁用（允许取消选择）
      if (this.formData.payableOfferPriceAddList[currentIndex].payableEntityId === optionValue) {
        return false;
      }

      // 检查此选项是否已被其他行选中
      return this.formData.payableOfferPriceAddList.some((row, index) =>
        index !== currentIndex &&
        row.payableEntityId === optionValue
      );
    },
    // 切换分区方案
    getOtherFeeDetail() {
      // 清空table数据
      if (!this.formData.partitionId) {
        this.isLoading = false;
        return;
      }
      this.isLoading = true;
      apiGetAffiliateById(this.formData.partitionId, false).then(res => {
        if (res.code === 200) {
          this.isLoading = false;
          this.subregionList = res.data.partitionAffiliateList || [];
        }
      });
    },
    // 批量添加
    batchAdd() {
      this.dialogVisible = true;
    },
    // 下载模板 type 1-主体 2-报价模板
    downloadFile(type = 2) {
      downloadTemplate(this.subregionList, this.expenseTypeList, this.specialFeeList, this.formData.partitionId, type);
    },
    // 导入主体
    importProviderData(data) {
      console.log(data, '导入主体');
      try {
        const { header } = data[0];
        if (!data || !data.length || header.length !== 2) {
          throw new Error(this.$t('basicData.templateError'));
        }
        const arr = data[0];
        this.importProvider(arr);
      } catch (error) {
        const { message } = error;
        this.$message.error(message);
      }
    },
    // 为空校验
    isEmpty(data, columns) {
      const arr = [];
      // 自定义提示文案
      const getCustomTip = (
        prop,
        label,
        dataIndex
      ) => {
        const baseTip = `${label}${this.$t('basicData.CannotBeEmpty')}`;
        // 补充数据行号
        return `${this.$t('basicData.row')}${dataIndex}${this.$t('basicData.line')}：${baseTip}`;
      };
      // 1.记录错误的主体和网点数据
      data.forEach(item => {
        columns.forEach(config => {
          const { rowIndex } = item;
          const { header, key } = config;
          const value = item[key];
          // 网点非必填
          if (key !== 'siteName' && !value || value === '') {
            const tip = getCustomTip(key, header, rowIndex);
            arr.push(tip); // 记录错误数据
          }
        });
      });
      return arr;
    },
    // 重复数据校验
    repeatData(data, columns) {
      // 1. 初始化缓存对象，用于记录每个字段的取值及对应的行号
      const fieldCache = {};
      // 提取需要校验的字段（providerName、siteName）
      const checkFields = columns.map(col => col.key);
      // 初始化错误提示数组
      const errorTips = [];

      // 2. 遍历数据，缓存每个字段的取值和对应行号
      data.forEach(item => {
        checkFields.forEach(field => {
          // 初始化该字段的缓存
          if (!fieldCache[field]) {
            fieldCache[field] = {};
          }
          const fieldValue = item[field]; // 当前字段的值
          const rowNum = item.rowIndex; // 当前行号

          // 缓存当前值对应的行号
          if (!fieldCache[field][fieldValue]) {
            fieldCache[field][fieldValue] = [];
          }
          if (fieldValue) {
            fieldCache[field][fieldValue].push(rowNum);
          }
        });
      });
      // 3. 遍历缓存，判断是否存在重复，并生成错误提示
      checkFields.forEach(field => {
        // 获取字段对应的中文表头（用于友好提示）
        const fieldHeader = columns.find(col => col.key === field).header;
        const valueMap = fieldCache[field];
        // 遍历每个取值对应的行号数组
        for (const [value, rowIndexes] of Object.entries(valueMap)) {
          // 行号数组长度大于1，说明该取值重复
          if (value && rowIndexes.length > 1) {
            // 格式化行号（如：1、5、7、8、9）
            const rowStr = rowIndexes.join('、');
            // 拼接错误提示
            errorTips.push(`${this.$t('basicData.row')}${rowStr}${this.$t('basicData.line')}${fieldHeader}（${this.$t('collectionCenter.value')}：${value}）${this.$t('basicData.重复')}`);
          }
        }
      });

      return errorTips;
    },
    // 校验数据是否为有效数据
    validateData(data) {
      // 1. 提取有效主体名称集合（去重，提高校验效率）
      const validProviderNames = new Set(
        this.providerList.map(item => item.providerName.trim()) // 去除首尾空格，兼容潜在格式问题
      );

      // 2. 提取有效网点名称集合（去重）
      const validSiteNames = new Set(
        this.outletsAllList.map(item => item.name.trim())
      );

      const errorMessages = [];
      // 3. 遍历待校验数据，逐条校验
      data.forEach(item => {
        const { providerName, siteName, rowIndex } = item;
        const rowTip = `${this.$t('basicData.row')}${rowIndex}${this.$t('basicData.line')}`; // 行号提示
        const errors = []; // 存储当前行的错误信息

        // 校验应付主体（providerName）
        const targetProvider = (providerName || '').trim();
        if (!validProviderNames.has(targetProvider)) {
          errors.push(`${this.$t('basicData.PayablePrincipal')}「${targetProvider}」${this.$t('basicData.IsInvalidData')}`);
        }

        // 校验网点（siteName）空值跳过
        const targetSite = (siteName || '').trim();
        if (targetSite && !validSiteNames.has(targetSite)) {
          errors.push(`${this.$t('basicData.Outlets')}「${targetSite}」${this.$t('basicData.IsInvalidData')}`);
        }

        // 若当前行有错误，拼接后存入总错误列表
        if (errors.length > 0) {
          errorMessages.push(`${rowTip}：${errors.join('；')}`);
        }
      });

      return errorMessages;
    },
    // 校验主体、网点级联
    validateProviderSite(data) {
      const providerIdGroup = this.groupByProviderId(this.outletsAllList);
      console.log(providerIdGroup, 'providerIdGroup');
      // 处理映射后的数据
      const providerData = [];
      const errorMsg = [];
      // 创建provider和outlets的Map索引以提高查找效率
      const providerMap = new Map();
      this.providerList.forEach(item => {
        providerMap.set(item.providerName, item);
      });

      const outletsMap = new Map();
      this.outletsAllList.forEach(item => {
        const key = `${item.name}_${item.providerName}`;
        outletsMap.set(key, item);
      });
      data.forEach(item => {
        const { rowIndex, providerName, siteName } = item;
        const obj = {};

        // 匹配主体、网点
        const isProvider = providerMap.get(providerName);
        console.log(isProvider, 'isProvider');
        const outletKey = `${siteName}_${providerName}`;
        const isSite = outletsMap.get(outletKey);
        console.log(isSite, 'isSite');

        if (isProvider) {
          obj.payableEntityId = isProvider.id;
          obj.payableEntityName = isProvider.providerName;
        }

        // 匹配网点
        if (item.siteName && item.providerName) {
          const outletKey = `${item.siteName}_${item.providerName}`;
          const isSite = outletsMap.get(outletKey);
          if (isSite) {
            obj.siteData = this.outletsAllList.filter(items => items.providerName === item.providerName);
            obj.siteIds = isSite.id;
            obj.siteName = isSite.name;
          } else {
            const tip = `${this.$t('basicData.row')}${rowIndex}${this.$t('basicData.line')} ${this.$t('basicData.Outlets')}「${item.siteName}」${this.$t('basicData.IsInvalidData')}`;
            errorMsg.push(tip);
          }
        }

        if (Object.keys(obj).length > 0) {
          providerData.push(obj);
        }
      });

      return {
        providerData,
        errorMsg
      };
    },
    // 数据解析（主体）
    importProvider(data) {
      try {
        const { header, results } = data;

        // 验证数据有效性
        if (!header || !Array.isArray(header) || !results || !Array.isArray(results)) {
          this.$message.error(this.$t('basicData.templateError'));
          return;
        }

        const rows = results.slice(2);
        if (!rows.length) {
          this.$message.warning(this.$t('basicData.noDataToImport'));
          return;
        }

        const fieldMapping = {
          '应付主体': 'providerName',
          '网点': 'siteName'
        };

        const result = [];
        const emptyRecords = []; // 记录空数据的行号

        for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
          const row = rows[rowIndex];
          const mappedRow = {};

          // 遍历所有表头，尝试映射
          for (let i = 0; i < header.length; i++) {
            const her = header[i];
            const value = row[her];
            if (fieldMapping[her]) {
              mappedRow[fieldMapping[her]] = value ? String(value).trim() : undefined;
            }
          }

          if (Object.keys(mappedRow).length > 0) {
            result.push({
              ...mappedRow,
              rowIndex: rowIndex + 1
            });
          } else {
            emptyRecords.push(rowIndex + 1); // 记录空行的行号
          }
        }

        console.log(result, '初始化');

        const columns = [
          {
            header: '应付主体',
            key: 'providerName',
            width: 40
          },
          {
            header: '网点',
            key: 'siteName',
            width: 40
          }
        ];
        let errors = [];
        // 1.记录空数据
        errors = this.isEmpty(result, columns);
        if (errors.length > 0) {
          throw new Error(errors.join('<br/>'));
        }
        // 2.记录重复数据(主体、网点)
        errors = this.repeatData(result, columns);
        if (errors.length > 0) {
          throw new Error(errors.join('<br/>'));
        }
        // 3.验证数据是否存在
        errors = this.validateData(result, columns);
        if (errors.length > 0) {
          throw new Error(errors.join('<br/>'));
        }
        // 4.校验网点、主体关联
        const { providerData, errorMsg } = this.validateProviderSite(result);
        if (errorMsg.length > 0) {
          throw new Error(errorMsg.join('<br/>'));
        }
        // 5.数据量不能超过500
        if (providerData.length > 500) {
          throw new Error(this.$t('receivablePayable.Only500PiecesImport'));
        }
        this.$set(this.formData, 'payableOfferPriceAddList', providerData);
      } catch (error) {
        const { message } = error;
        this.$message({
          message,
          type: 'warning',
          dangerouslyUseHTMLString: true
        });
      }
    },

    // 导入报价
    importData(list) {
      console.log(list, '导入数据');
      try {
        const { header } = list[0];
        if (!list || !list.length || header.length !== 13) {
          throw new Error(this.$t('basicData.templateError'));
        }
        const data = list[0];
        const rulesData = list[1];
        this.ImportFileList(data, rulesData);
      } catch (error) {
        const { message } = error;
        this.$message?.error(message);
      }
    },
    // data 普通规则 rulesData 特殊规则
    ImportFileList(data, rulesData) {
      // 参数校验
      if (!data || !rulesData) {
        return;
      }

      // 表单验证
      const validateForm = (formRef) => {
        return new Promise((resolve) => {
          if (!this.$refs[formRef]) {
            resolve(false);
            return;
          }

          this.$refs[formRef].validate(valid => {
            if (!valid) {
              resolve(false);
              return;
            }
            resolve(true);
          });
        });
      };

      // 主体选择验证
      if (!this.formData.payableOfferPriceAddList || !this.formData.payableOfferPriceAddList.length) {
        this.$message?.warning(this.$t('basicData.PleaseSelectThePayableEntity'));
        return;
      }

      // 串行验证表单
      validateForm('form').then(formValid => {
        if (!formValid) return;

        return validateForm('tableForm');
      }).then(tableFormValid => {
        if (tableFormValid === false) return;
        if (tableFormValid === true) {
          console.log(this.formData);
          const obj = importLogistics(this.formData, data, rulesData);
          apiPayableOfferPriceDetailBatchInsert({
            ...this.formData,
            detailList: obj.arr,
            otherRulesList: obj.rulesArr
          }).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
              this.dialogVisible = false;
              this.$emit('updatePage', true);
            }
          });
          console.log(obj);
        }
      }).catch(error => {
        console.error('Validation error:', error);
      });
    },
    // 重置
    reset() {
      this.$refs.form.resetFields();
      this.$refs.form.clearValidate();
      this.formData.partitionId = '';
      this.formData.payableOfferPriceAddList = [];
    },
    /**
     * 按providerId对数据进行分组
     * @param {Array} arr - 原始数据数组
     * @returns {Object} - 分组后的对象，key为providerId，value为对应分组的数据数组
     */
    groupByProviderId(arr) {
      // 使用reduce方法实现分组
      return arr.reduce((groupedObj, currentItem) => {
        // 获取当前对象的providerId（作为分组key）
        const providerKey = currentItem.providerId;

        // 1. 如果该providerId对应的分组不存在，先初始化一个空数组
        if (!groupedObj[providerKey]) {
          groupedObj[providerKey] = [];
        }

        // 2. 将当前对象添加到对应providerId的分组数组中
        groupedObj[providerKey].push(currentItem);

        // 返回累加后的分组对象
        return groupedObj;
      }, {}); // 初始值为空对象，用于存储分组结果
    }
  }
};
</script>

<style scoped lang="scss">
.drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;

  .form-container {
    padding: 15px 20px;
    height: calc(100vh - 140px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .drawer__footer {
    padding: 15px;
    justify-content: flex-end;
    border-top: 1px solid #ccc;
  }
}
.title {
  padding: 15px 10px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}
</style>
